import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import useSnackbar from "../../hooks/useSnackbar";
import {
  Box,
  Grid,
  Typography,
  Button,
  TextField,
  Menu,
  MenuItem,
  Paper,
  InputAdornment,
} from "@mui/material";
import AgGridPaginatedTable from "../../components/AgGridPaginatedTable";
import { savedSearchListTable } from "../../config/grid-column-defs";
import {
  getSavedSearchList,
  getsavedSearchDownloadExport,
} from "../../api/saved-search";
import useErrorHandler from "../../hooks/useErrorHandler";
import SearchIcon from "@mui/icons-material/Search";
import DownloadIcon from "@mui/icons-material/Download";
import DownloadDialog from "../../components/DownloadDialogComp";
import { getLists } from "../../api/reports";

export default function SavedSearch(e) {
  const dispatch = useDispatch();
  const errorHandler = useErrorHandler();
  const [reportName, setReportName] = useState("");
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);

  const [anchorE, setAnchorE] = useState(null);
  const open = Boolean(anchorE);

  const [inputValue, setInputValue] = useState("");
  const handleClose = () => {
    setAnchorE(null);
  };
  const handleClick = (event) => {
    setAnchorE(event.currentTarget);
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const open1 = Boolean(anchorEl);
  const handleClick1 = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose1 = () => {
    setAnchorEl(null);
  };

  //let obj = tableDef.find((o) => o.headerName === "");
  //addAdditionalColumn(obj, dispatch);

  const [tableRefreshCount, setTableRefreshCount] = useState(0);
  function refreshTable() {
    setTableRefreshCount((prev) => prev + 1);
  }
  const [dialogOpen, setDialogOpen] = useState(false);
  const dialogAction = useSelector((state) => state.dialog);
  const [downloadInProgress, setDownloadInProgress] = useState(false);
  const [percentComplete, setPercentComplete] = useState(0);

  let obj = savedSearchListTable.find((o) => o.headerName === "DOWNLOAD");
  addAdditionalColumnDownload(obj, dispatch);

  const getDownloadDocumentById = (reportName) => {
    setPercentComplete(0);

    const options = {
      headers: {
        authorization: user?.token,
      },
      responseType: "blob",
      onDownloadProgress: function (progressEvent) {
        const newPercentComplete = Math.floor(
          (progressEvent.loaded / progressEvent.total) * 100
        );
        setPercentComplete(newPercentComplete); // Update the percentComplete state
      },
    };
    setDownloadInProgress(true); // Start the download progress
    getsavedSearchDownloadExport(
      {
        type: "savedsearch",
        report_name: reportName,
        file: "xlsx",
      },
      options
    )
      .then((blob) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob.data);
        link.setAttribute("download", `${reportName}`);
        document.body.appendChild(link);
        link.click();
        setDialogOpen(false);
        setDownloadInProgress(false);
      })
      .catch((err) => {
        errorHandler(err);
        setDownloadInProgress(false);
        setDialogOpen(false);
      })
      .finally(() => {
        setDownloadInProgress(false);
        setDialogOpen(false);
        // Download completed or errored, stop progress
      });
  };

  useEffect(() => {
    if (!dialogAction.type) return;
    switch (dialogAction.type) {
      case "DOWNLOADVIEW":
        dispatch({ type: "" });
        setDialogOpen(true);
        getDownloadDocumentById(dialogAction?.data.table_name);
        break;

      default:
        break;
    }
  }, [dialogAction]);

  async function getSavedSearchListTableData(limit, offset) {
    try {
      const { data } = await getLists(user.token, {
        limit,
        offset,
        report_name: reportName,
        type: "savedsearch",
        list_name: inputValue,
      });
      return {
        rows: data.data,
        total: data.total,
        error: false,
      };
    } catch (error) {
      console.log(error);
      //snackbar.showError("No Data Found");
      errorHandler(error);
      return { error: true };
    } finally {
      // setLoading(false)
    }
  }
  // useEffect(()=>{
  //   if(user.token){
  //   getSavedSearchListTableData(10,0);}
  // },[])
  const handleInputChange = async (event) => {
    setInputValue(event);
    refreshTable();
  };
  const handleResetChange = async () => {
    setInputValue("");
    refreshTable();
  };
  return (
    <>
      <Box className="viewBox">
        <Box className="viewDetilsBox">
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            p={1}
          >
            <Typography
              component="h5"
              fontWeight={500}
              className="pageHeading1"
            >
              Saved Search
            </Typography>
          </Box>

          <Grid container ml={1}>
            <TextField
              size="medium"
              // id="search-input"
              // label="Search Name"
              variant="outlined"
              placeholder="Name"
              onChange={(event) => handleInputChange(event.target.value)}
              value={inputValue}
              autoComplete="off"
              sx={{
                width: "270px",
                marginBottom: "10px",
                "& .MuiInputBase-root": {
                  height: "37px",
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
            {inputValue && (
              <div style={{ marginBottom: "2px" }}>
                <Button
                  // type="button"
                  style={{ color: "black" }}
                  onClick={() => handleResetChange()}
                >
                  Reset
                </Button>
              </div>
            )}
          </Grid>
          {/* <Box className="filter-box" component="form" onChange={refreshTable}>
          <Grid container alignItems="center">
            <Grid item md={3} sm={6} xs={12}>
              <Grid container alignItems="center">
                <Grid item md={3} sm={4} xs={3}>
                  <Button
                    size="small"
                    type="button"
                    id="basic-button"
                    aria-controls={open ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    onClick={handleClick}
                    sx={{ color: "black", fontWeight: "600" }}
                  >
                    <SearchIcon /> <KeyboardArrowDownIcon />
                  </Button>
                </Grid>

                <Grid
                  item
                  md={9}
                  sm={8}
                  xs={9}
                  alignItems="center"
                  display="flex"
                >
                  <TextField
                    size="small"
                    label=""
                    name="search"
                    value={reportName}
                    onChange={(e) => {
                      setReportName(e.target.value);
                    }}
                  />
                  <Button
                    size="small"
                    type="button"
                    sx={{ color: "black", fontWeight: "600" }}
                  >
                    Go
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={2} sm={4} xs={12} mt={{ xs: 1, sm: 0 }}>
              <Button
                id="basic-button1"
                aria-controls={open1 ? "basic-menu1" : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? "true" : undefined}
                onClick={handleClick1}
                sx={{ color: "black", fontWeight: "600" }}
              >
                Actions <KeyboardArrowDownIcon />
              </Button>
              <Menu
                id="basic-menu1"
                anchorEl={anchorEl}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  "aria-labelledby": "basic-button1",
                }}
              >
                <MenuItem onClick={handleClose1}>Columns</MenuItem>
                <MenuItem onClick={handleClose1}>Filter</MenuItem>
                <MenuItem onClick={handleClose1}>Data</MenuItem>
                <MenuItem onClick={handleClose1}>Format</MenuItem>
                <MenuItem onClick={handleClose1}>Chart</MenuItem>
                <MenuItem onClick={handleClose1}>Group By</MenuItem>
                <MenuItem onClick={handleClose1}>Pivot</MenuItem>
                <MenuItem onClick={handleClose1}>Report</MenuItem>
                <MenuItem onClick={handleClose1}>Download</MenuItem>
                <MenuItem onClick={handleClose1}>Help</MenuItem>
              </Menu>
            </Grid>
          </Grid>
        </Box> */}

          <AgGridPaginatedTable
            getTableRows={getSavedSearchListTableData} //getSavedSearchListTableData}
            columns={savedSearchListTable}
            perPage={10}
            refreshCounter={tableRefreshCount}
          />
          <DownloadDialog
            open={dialogOpen}
            onClose={() => setDialogOpen(false)}
            downloadInProgress={downloadInProgress}
            percentComplete={percentComplete}
          />
        </Box>
      </Box>
    </>
  );
}
function addAdditionalColumnDownload(obj, dispatch) {
  if (obj === undefined) {
    savedSearchListTable.unshift({
      headerName: "DOWNLOAD",
      field: "actions",
      maxWidth: 100,
      cellClass: "downloadCenter",
      cellRendererFramework: (params) => (
        <Box>
          <Button
            title="Export CSV"
            className="actionIcon"
            onClick={() => {
              dispatch({ type: "DOWNLOADVIEW", data: params.data });
            }}
          >
            <DownloadIcon />
          </Button>
        </Box>
      ),
    });
  }
}
